import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { ZERO } from 'shared/constants'
import { Button, Container } from './styles'
import type { RequestSelectedUserDataProps } from './types'

const RequestSelectedUserData: React.FC<RequestSelectedUserDataProps> = ({
  onClick,
  requestedUsersAmount = ZERO,
  isConfirming,
}) => {
  const { t } = useFavurTranslation()

  return (
    <Container>
      <Button
        disabled={requestedUsersAmount === ZERO}
        variant="contained"
        onClick={onClick}
        data-testid="request-selected-user-data-button"
      >
        {t(isConfirming ? 'button.confirmRequests' : 'button.requestFromSelected', {
          requestedUsersAmount,
        })}
      </Button>
    </Container>
  )
}

export default RequestSelectedUserData
